// extracted by mini-css-extract-plugin
module.exports = {"propertyGroupLabel":"style__propertyGroupLabel___3dg-u","iconWrapper":"style__iconWrapper___2FyWp"};